import React from 'react'
import Payroll from '../../components/page-content/our-apps/payroll'

export const Page = () => {
  return <Payroll />
}

export default Page
